import React from "react";
import { useSelector } from "react-redux";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import { actionCreators } from "./redux/membershipRevenueSagas";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import RecurringRevenue from "./smartComponents/recurringRevenue";
import PreviousRecurringRevenue from "./smartComponents/prevRecurringRevenue";
import RecurringRevenueYearToDate from "./smartComponents/recurringRevenueYearToDate";
import PreviousRecurringRevenueYearToDate from "./smartComponents/prevRecurringRevenueYearToDate";
import YearOverYear from "./smartComponents/yearOverYear";
import AverageRevenuePerUnit from "./smartComponents/averageRevenuePerUnit";
import RemainingRevenue from "./smartComponents/remainingRevenue";
import NextMonthRevenue from "./smartComponents/nextMonthRevenue";
import LearnMore from "../../../components/learnMore/learnMore";
import { useFetchDataWithRevenueType } from "../hooks/dataFetchingHooks";

const MembershipRevenueModule = (props) => {
  useFetchDataWithRevenueType({
    moduleName: "membershipRevenue",
    props,
    fetchData: actionCreators.fetchCurrentUser,
    updateData: actionCreators.updateAllData
  });

  const isLoading = useSelector((state) => state.membershipRevenue.isLoading);

  const displayAutopays = useSelector((state) => state.membershipRevenue.displayAutopays);

  const dataPoints = useSelector((state) => state.membershipRevenue.membershipDraft.recurring);

  const size =
    dataPoints && Object.values(dataPoints).some((dataPoint) => dataPoint.value > 99999999)
      ? 40
      : 46;

  return (
    <SectionToggle
      title="Membership Revenue"
      learnMore={<LearnMore {...props.learnMore} html />}
      customClass={`membershipdraftsWidget ${isLoading ? "" : "active"}`}
      height={800}
      isLoading={isLoading}
      content={
        <div>
          <div className="section-group height-175">
            <span className="width-50">
              <RecurringRevenue size={size} />
            </span>

            {displayAutopays && (
              <span className="width-50">
                <RemainingRevenue size={size} />
              </span>
            )}
          </div>
          <div className="section-group height-175">
            {displayAutopays && (
              <span className="width-50">
                <NextMonthRevenue size={size} />
              </span>
            )}
          </div>
          <div className="section-group height-175">
            <span className="width-50">
              <AverageRevenuePerUnit size={size} />
            </span>
            <span className="width-50">
              <PreviousRecurringRevenue size={size} />
            </span>
          </div>
          <div className="section-group height-175">
            <span className="width-50">
              <RecurringRevenueYearToDate size={size} />
            </span>
            <span className="width-50">
              <PreviousRecurringRevenueYearToDate size={size} />
            </span>
          </div>

          <div className="section-group" style={{ width: "100%" }}>
            <span className="top">
              <SectionContainer title="Year over Year Comparison">
                <YearOverYear />
              </SectionContainer>
            </span>
          </div>
        </div>
      }
    />
  );
};
export default MembershipRevenueModule;
